module.exports = __webpack_public_path__ + "img/w25-b3.7bf1f0aa.jpg";